export const labelContainerStyles = `flex flex-wrap max-w-full tracking-[0.4px] md:max-w-full not-italic`

export const otpInputContainerStyles = `w-full mb-2`

export const otpFieldLabelStyles = `text-sm-medium mb-3`

export const otpInputFocusStyleStyles = `border-[2px] shadow-[0_1px_2px_rgba(0,0,0,0.08)] outline-none`

export const otpInputErrorStyleStyles = `border-[2px]`

export const otp_InputContainer_Styles = `w-[38px] max-w-[48px] flex-[1] rounded-lg border-[1px] text-sm-medium last-child:!mr-0`

export const minusIconStyles = `ml-3`

export const errorMessageStyles = `text-xs-regular`
